// extracted by mini-css-extract-plugin
export default {"NoDataTable":"RecurCheckoutPage_NoDataTable__bzYmo"};